import {Component, OnDestroy, OnInit} from '@angular/core';
import {AlertService} from "../services";
import {ActivatedRoute} from '@angular/router';
import {first} from 'rxjs/operators';
import {ResourceService} from "../services/resource.service";
import {ComponentTitleService} from "../services/componentTitle.service";
import {FuseTranslationLoaderService} from "../../../@fuse/services/translation-loader.service";
import { locale as polish } from './i18n/pl';
import {Resource} from "../models/resource";
import {Training} from "../models/training";
import {TrainingService} from "../services/training.service";
import {TrainingItems} from "../models/trainingItems";
import {Subject} from "rxjs";
import {MatDialog} from "@angular/material/dialog";
import {TrainingListModalComponent} from "../training/trainingListModal.component";

@Component({
    templateUrl: './resourceDetails.component.html',
    styleUrls: ['./resourceDetails.component.scss']
})

export class ResourceDetailsComponent implements OnDestroy, OnInit {
    id: string;
    resource: Resource;
    trainings: Training[] = [];
    trainingsLoading: boolean = false;
    loading: boolean = false;

    private _unsubscribeAll: Subject<any>;

    constructor(
        private route: ActivatedRoute,
        private alertService: AlertService,
        private resourceService: ResourceService,
        private componentTitleService: ComponentTitleService,
        private translationLoader: FuseTranslationLoaderService,
        private trainingService: TrainingService,
        private dialog: MatDialog
    ) {
        this._unsubscribeAll = new Subject();
        this.translationLoader.loadTranslations(polish);

        componentTitleService.clearTitle();
        componentTitleService.addPart('Resources');
    }

    ngOnInit() {
        this.id = this.route.snapshot.params['id'];
        this.resource = this.route.snapshot.data.resource;

        if (this.resource) {
            this.componentTitleService.addPart(this.resource.name);
            this.loadTrainings();
        }
    }

    ngOnDestroy(): void {
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }

    loadTrainings(): void {
        this.trainingsLoading = true;

        if (this.resource && this.resource.serialNumber) {
            this.trainingService.getTrainings({
                resourceId: this.resource.id,
                limit: 50,
                sortCol: 'createdAt',
                sortDir: 'desc'
            }).pipe(first()).subscribe(
                (res: TrainingItems) => {
                    this.trainings = res.items;
                    this.trainingsLoading = false;
                },
                error => {
                    this.alertService.error(error);
                    this.trainingsLoading = false;
                }
            );
        } else {
            this.trainingsLoading = false;
        }
    }

    openTrainingListModal(): void {
        const dialogRef = this.dialog.open(TrainingListModalComponent, {
            width: '90vw',
            maxWidth: '1400px',
            height: '80vh',
            panelClass: 'training-list-modal',
            data: {
                resourceId: this.resource.id,
                title: 'Training History for ' + this.resource.name
            }
        });
    }
}